import React from 'react'
import { Button, Card, Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as ReferralIcon } from 'static/svg/referral-card/referral-icon.svg'
import { REFERRAL_TYPEFORM_URL } from 'settings/_externalLinksSettings'

import * as S from './styles'

export const ReferralCard = (): JSX.Element => {
  const handleReferralClick = () => {
    window.open(REFERRAL_TYPEFORM_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <Card variant='regular'>
      <Typography variant='content1'>
        Referenciamento
      </Typography>

      <S.IconWrapper>
        <ReferralIcon />
      </S.IconWrapper>

      <S.TextWrapper>
        <Typography variant='content3' center>
          Referenciamento é o encaminhamento de um paciente que está em acompanhamento fora da Telavita para os cuidados oferecidos pela Telavita.
        </Typography>
        <Typography variant='content3' center>
          Utilize quando as necessidades do paciente puderem ser melhor atendidas pelos serviços disponibilizados por nós.
        </Typography>
      </S.TextWrapper>

      <S.ButtonWrapper>
        <Button
          variant='contained'
          color='primary'
          inlineStyles={{ width: '100%' }}
          onClick={handleReferralClick}
        >
          Referenciar para a Telavita
        </Button>
      </S.ButtonWrapper>
    </Card>
  )
}
